/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const CREATE_OR_EDIT_TAG_DIALOG_ID = 'createOrEditTagDialogId';
